import React from 'react';

import PropTypes from 'prop-types';

import { MediaCard } from '@adsk/acc-sitevision-web-lib';
import { Box } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import BlockRemoveButton from '../../BlockRemoveButton';

/**
 * A component rendering Photo entity block.
 * @param entity
 * @param selected
 * @param onRemoveClick
 * @param onChange
 * @param onClick
 * @param onReferenceClickAnalytics
 * @return {*}
 * @constructor
 */
const PhotoEntityBlock = ({
  entity,
  onRemoveClick,
  onClick,
  onReferenceClickAnalytics,
}) => {
  const handleClick = () => {
    onClick && onClick();
    onReferenceClickAnalytics && onReferenceClickAnalytics();
  };

  return (
    <Box width="50%" padding="8px" display="inline-block" verticalAlign="top">
      <MediaCard
        hideCheckbox
        media={{ ...entity, uid: entity.id }}
        renderOverlay={() =>
          onRemoveClick && (
            <div className="button">
              <BlockRemoveButton
                style={{
                  backgroundColor: theme.colors.white,
                }}
                onClick={() => onRemoveClick && onRemoveClick(entity)}
              />
            </div>
          )
        }
        onRemove={onRemoveClick && (() => onRemoveClick(entity))}
        onClick={handleClick}
      />
    </Box>
  );
};

PhotoEntityBlock.propTypes = {
  /**
   * The Photo entity we need to render.
   */
  entity: PropTypes.shape({
    title: PropTypes.string,
    createdAt: PropTypes.string,
    takenOn: PropTypes.string,
    takenBy: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
    thumbnailUrl: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  onReferenceClickAnalytics: PropTypes.func,
  onRemoveClick: PropTypes.func,
};

export default PhotoEntityBlock;
